const userActions = {
  FIRST_STEP: 'FIRST_STEP', // when the form is initialised
  GO_BACK: 'GO_BACK', // when the user pressed the Back button
  MANUAL: 'MANUAL', // when the user is forged to a step with #fc:<STEP ID>
  SKIP: 'SKIP', // when the user skipped a step pressing Enter
  SUBMIT: 'SUBMIT', // when the user submits an answer (auto-jump functionality, Next or Submit button)
};
export default userActions;
